// Utility filter functions
// Migrated from client/filters.js
import moment from 'moment';
import numeral from 'numeral';

export const fixed = (value: number): string => {
  if (value) {
    return value.toFixed(1);
  }
  return '';
};

export const dtol = (value: string | Date): string => {
  const date = moment(value);
  return date.format('ddd DD MMM');
};

export const dtos = (value: string | Date): string => {
  const date = moment(value);
  return date.format('DD/MM/YYYY');
};

export const dtoh = (value: string | Date): string => {
  const date = moment(value);
  return date.format('HH:mm');
};

export const itok = (value: number): string => {
  return numeral(value).format('0 a');
};

export const itoa = (value: number): string => {
  return value.toFixed(2).toString();
};

export const stomn = (value: number): number => {
  return Math.ceil(value / 60);
};

export const stoh = (value: number): string => {
  return moment('2015-01-01')
    .startOf('day')
    .seconds(value)
    .format('HH[h]mm');
};

export const mtokm = (value: number): number | string => {
  if (value) {
    if ((value / 1000) % 1 === 0) return value / 1000;
    return (value / 1000).toFixed(1);
  }
  return '';
};

export const firstLetter = (value: string): string => {
  if (!value) return '';
  return value[0] + '.';
};

export const highlight = (words: string, query: string): string => {
  const pattern = new RegExp(query, 'gi');
  return words.replace(
    pattern,
    '<mark class="highlight-output">' + '$&' + '</mark>'
  );
};

